export default __webpack_public_path__ + "static/media/graduation-animate.0debb2a4.svg";